"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _from = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/from"));
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var _oidcClient = require("oidc-client/lib/oidc-client.rsa256");
var _baseClient = _interopRequireDefault(require("./baseClient"));
var _url = require("../url");
// Roughly the same interface as the old kcHelper

const LOGIN_PROCESS_KEY = 'au-login-process';
const LOGIN_STATE_KEY = 'au-login-process-state';
function decodeToken(jwtString) {
  return JSON.parse(atob(jwtString.split('.')[1]));
}
function generateNonce(length = 40) {
  // taken from https://stackoverflow.com/questions/9407892/how-to-generate-random-sha1-hash-to-use-as-id-in-node-js/14869745#answer-26410127
  const random = new Uint8Array(length / 2);
  (window.crypto || window.msCrypto).getRandomValues(random);
  return (0, _from.default)(random, byte => {
    var _context;
    return (0, _slice.default)(_context = '0' + byte.toString(16)).call(_context, -2);
  }).join('');
}
class CodeFlowClient extends _baseClient.default {
  init(config) {
    super.init(config);

    // this client cannot be reinitialized ATM
    if (this.initialized) {
      throw 'auth client is already initialized';
    }

    // oidc-client defaults to using session storage which can be read by all JS.
    // Use in-memory storage to reduce vulnerability.
    const userStore = new _oidcClient.WebStorageStateStore({
      store: new _oidcClient.InMemoryWebStorage()
    });

    // build UserManager config
    const userMgrConfig = {
      authority: `https://accounts.${config.baseDomain}/v1/auth/oidc/`,
      client_id: config.clientId,
      redirect_uri: config.redirectUri || decodeURIComponent(window.location.href),
      response_type: 'code',
      scope: 'openid',
      automaticSilentRenew: true,
      // NOTE: this does not seem to work on its own
      loadUserInfo: true,
      userStore
    };
    if (config.idpHint) {
      userMgrConfig.extraQueryParams = {
        idp_hint: config.idpHint
      };
    }
    this.userMgr = new _oidcClient.UserManager(userMgrConfig);
    this.userMgr.clearStaleState();
    this.userMgr.events.addAccessTokenExpiring(() => {
      this.userMgr.signinSilent().then(user => {
        this._handleUserResponse(user);
      }).catch(e => {
        this._loggedIn = false;
        console.error('silent renew error', e.message); // eslint-disable-line no-console
      });
    });

    this.userMgr.events.addSilentRenewError(e => {
      this._loggedIn = false;
      console.error('silent renew error', e.message); // eslint-disable-line no-console
    });

    this._initialized = true;
  }
  async logIn() {
    super.logIn();
    this.userMgr.clearStaleState();
    let loginState = window.localStorage.getItem(LOGIN_PROCESS_KEY);
    if (loginState === 'failed') {
      window.localStorage.removeItem(LOGIN_PROCESS_KEY);
      window.localStorage.removeItem(LOGIN_STATE_KEY);
      loginState = null;
    }
    switch (window.localStorage.getItem(LOGIN_PROCESS_KEY)) {
      case null:
        {
          // Intial load

          // generate a nonce; may enhance security
          const nonce = generateNonce();
          window.localStorage.setItem(LOGIN_STATE_KEY, nonce);
          return this.userMgr.signinRedirect({
            state: nonce,
            useReplaceToNavigate: true
          }).then(() => {
            window.localStorage.setItem(LOGIN_PROCESS_KEY, 'successful');
            // A redirect will be shortly performed, but to avoid code relying on
            // this promise resovling from executing we need to return a
            // never-resolving promise.
            return new _promise.default(() => {});
          }).catch(err => {
            console.error(err); // eslint-disable-line no-console
            window.localStorage.setItem(LOGIN_PROCESS_KEY, 'failed');
            throw err;
          });
        }
      case 'successful':
        {
          window.localStorage.removeItem(LOGIN_PROCESS_KEY);
          const state = window.localStorage.getItem(LOGIN_STATE_KEY);
          if (!state) {
            return _promise.default.reject('local login state is missing');
          }
          window.localStorage.removeItem(LOGIN_STATE_KEY);
          return this.userMgr.signinCallback().then(user => {
            if (state !== user.state) {
              throw 'local state does not match returned state';
            }

            // remove rediect query params
            const cleanUrl = (0, _url.removeQueryParams)(window.location.href, ['code', 'state', 'redirect_uri']);
            window.history.replaceState({}, document.title, cleanUrl);
            this._handleUserResponse(user);
            this._loggedIn = true;
          }).catch(err => {
            console.error(err); // eslint-disable-line no-console
            throw err;
          });
        }
      // TODO: handle 'failed' state
    }
  }

  logOut() {
    // Not implemented since currently this will do nothing but essentially
    // reload the page.
    console.warn('logOut not implemented'); // eslint-disable-line no-console
  }

  _handleUserResponse(user) {
    const refreshing = user.access_token !== this._accessToken;
    if (user.profile) {
      this._userInfo = user.profile; // is actually a merge of ID token and userInfo
    }

    this._accessToken = user.access_token || this._accessToken;
    this._accessTokenPayload = user.access_token ? decodeToken(user.access_token) : this._accessTokenPayload;
    this._refreshToken = user.refresh_token || this._refreshToken;
    this._refreshTokenPayload = user.refresh_token ? decodeToken(user.refresh_token) : this._refreshTokenPayload;
    if (refreshing) {
      this._onAuthRefreshSuccess();
    }
  }
}
exports.default = CodeFlowClient;